import React, { useState } from "react";
import "./style.css";
import Header from '../../modules/panel/header'
import Sidebar from '../../modules/panel/sidebar'
import DataTable from 'react-data-table-component';
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import Footer from "../../modules/panel/footer";

function Page(props) {

  const { columns, paginationOptions, users, show, setShow, form, setForm, handledAdd, enable, setEnable, handledUpdate, errors } = props,
    [filterText, setFilterText] = useState(''),
    filteredItems = (users.listUsers ? users.listUsers : []).filter(item => {
      return (
        (item.full_name && item.full_name.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.username && item.username.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.email && item.email.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.created && item.created.includes(filterText))) ? true : false;
    });

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 main-panel">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2">Usuarios</h1>
              <div className="btn-toolbar mb-2 mb-md-0">
                <div className="btn-group me-2"></div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <div className="row justify-content-between align-items-center flex-grow-1">
                  <div className="col-sm-4 col-md-4 mb-3 mb-sm-0">
                    <div className="search-card input-group">
                      <div className="input-group-prepend">
                        <div className="input-group-text">
                          <i className="fas fa-search"></i>
                        </div>
                      </div>
                      <input type="search" className="form-control datatableSearch" placeholder="Buscar..." aria-label="Search orders" value={filterText} onChange={(e) => setFilterText(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-sm-8 col-md-8 mb-9 mb-sm-0" style={{ textAlign: "right" }}>
                    <Button variant="primary" onClick={() => setShow({ ...show, add: true })}><i className="fas fa-plus"></i>&nbsp;&nbsp;Crea Usuario</Button>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                striped
                  columns={columns}
                  data={filteredItems}
                  pagination
                  noDataComponent={
                    <p style={{ color: "rgb(200, 200, 200)", fontStyle: "italic", paddingTop: 40, paddingBottom: 60 }}>
                      <img className="avatar-img" src={"/assets/no-data.png"} alt="" />
                      <span className="no-data">No hay registros para mostrar</span>
                    </p>
                  }
                  paginationComponentOptions={paginationOptions}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />

      {/* Add new user */}
      <Modal show={show.add} onHide={() => setShow({ ...show, add: false })} className="modal-panel">
        <Modal.Header closeButton>
          <Modal.Title><i className="fas fa-plus"></i>&nbsp;&nbsp;Crea Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Nombre Completo</Form.Label>
              <Form.Control type="text" style={{ borderColor: (errors.full_name) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su nombre completo..." value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Nombre de usuario</Form.Label>
              <Form.Control type="text" style={{ borderColor: (errors.username) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su nombre de usuario..." value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control type="email" style={{ borderColor: (errors.email) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su correo electrónico..." value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </Form.Group>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Contraseña</Form.Label>
                  <Form.Control type="password" style={{ borderColor: (errors.password) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su contraseña..." value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Repetir Contraseña</Form.Label>
                  <Form.Control type="password" style={{ borderColor: (errors.reptpassword) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su contraseña..." value={form.reptpassword} onChange={(e) => setForm({ ...form, reptpassword: e.target.value })} />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow({ ...show, add: false })}><i className="fas fa-times"></i>&nbsp;&nbsp;Cerrar</Button>
          <Button variant="success" onClick={handledAdd}><i className="fas fa-save"></i>&nbsp;&nbsp;Guardar</Button>
        </Modal.Footer>
      </Modal>

      {/* Update user */}
      <Modal show={show.edit} onHide={() => setShow({ ...show, edit: false })} className="modal-panel">
        <Modal.Header closeButton>
          <Modal.Title><i className="fas fa-edit"></i>&nbsp;&nbsp;Editar Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Nombre Completo</Form.Label>
              <Form.Control type="text" style={{ borderColor: (errors.full_name) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su nombre completo..." value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Nombre de usuario</Form.Label>
              <Form.Control type="text" readOnly placeholder="Escriba su nombre de usuario..." value={form.username} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control type="email" style={{ borderColor: (errors.email) ? "rgb(200, 55, 55)" : "#e7eaf3" }} placeholder="Escriba su correo electrónico..." value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </Form.Group>
            <Form.Label>Contraseña</Form.Label>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <InputGroup className="mb-3">
                <Form.Control type="password" placeholder="Escriba su contraseña..." disabled={enable} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                <Button variant="success" onClick={() => setEnable(!enable)}><i className={(enable) ? "fas fa-toggle-on" : "fas fa-toggle-off"}></i>&nbsp;&nbsp;{(enable) ? "Habilitar" : "Desabilitar"}</Button>
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Activo</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control type="text" readOnly value={(form.active) ? "Activo" : "Desactivo"} />
                <Button variant={(!form.active) ? "success" : "danger"} onClick={() => setForm({ ...form, active: !form.active })}>
                  <i className={(form.active) ? "fas fa-toggle-on" : "fas fa-toggle-off"}></i>&nbsp;&nbsp;{(!form.active) ? "Activo" : "Desactivar"}
                </Button>
              </InputGroup>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow({ ...show, edit: false })}><i className="fas fa-times"></i>&nbsp;&nbsp;Cerrar</Button>
          <Button variant="success" onClick={handledUpdate}><i className="fas fa-save"></i>&nbsp;&nbsp;Guardar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Page;